import React from 'react';

import { YOUTUBE_URL } from '../constants';
import type { VideoBlockProps } from '../interfaces';
import Video from './Video';
import YouTube from './YouTube';

const VideoBlock = ({ config, content }: VideoBlockProps) => {
  if (!content.src) return null;

  const isYouTubeURL = content.src?.includes(YOUTUBE_URL);
  const width = Number(config?.width);
  const maxWidth = width && !isNaN(width) ? `max-w-[${width}px]` : '';

  if (isYouTubeURL) {
    return <YouTube config={config} content={content} maxWidth={maxWidth} />;
  }

  return <Video config={config} content={content} maxWidth={maxWidth} />;
};

export default VideoBlock;
